'use client'
import { TOptionsBase } from 'i18next'
import { useCallback } from 'react'
import { useTranslation as useI18NTranslation } from 'react-i18next'

export const useComponentTranslation = (prefix: string) => {
  const { t: tBase } = useI18NTranslation()

  const t = useCallback(
    (key: string, options?: TOptionsBase & Record<string, unknown>) => {
      return tBase(`${[prefix, key].filter((i) => i).join('.')}`, options)
    },
    [prefix, tBase]
  )

  return t
}
